import * as Yup from 'yup'
import { useFormik } from "formik"
import { Button } from "@mui/material";
import { store } from "../../../stores/Store";
import Ajax from "../../../Ajax";
import { Alert, AlertModal } from "../../..";
import React from "react";
import { SelectOption } from "../fields/SelectField";
import { RadioSelectField } from "../fields/RadioSelectField";
import Field from "../fields/Field";

export default function AutomationNodeCreateForm ({caseUid, enquiryUid = null}) {

    const [enquiryUidRef, setEnquiryUidRef] = React.useState(enquiryUid)
    
    // const enquiryOptions: SelectOption[] = store.NodeStore.getFolderChildren.filter(node => node.uid.includes("ENQUIRY")).map(node => {
    //     return {
    //         value: node.uid, 
    //         label: store.NodeStore.getDisplayName(node),
    //         help: store.EnquiryStore.getSubject(node)?.name
    //     }
    // })

    var formik = useFormik({
        initialValues: {
            name: ""
        },
        validationSchema: Yup.object({
            name: Yup.string().required("This field is required"),
        }),
        onSubmit: async (values) => {

            var an = {
                "status": "CREATED",
                "enquiry": {uid: enquiryUidRef},
                "dataSources": [],
                "automations": [],
                "uid": "AUTOMATION_X",
                "name": values.name
            }

            await Ajax.Node.Create("automation", caseUid, an).then((response) => {
                store.AlertStore.Close()
                store.NodeStore.navigateNode(response.data?.uid)
                store.NodeStore.refreshFolderNode()
            }).catch((response) => {
                Alert({message: response.data?.detail ? response.data?.detail : "Unable to create Automation"})
            })
        }
    })

    return (
        <form className="form" onSubmit={formik.handleSubmit}>    
            <div>
                {enquiryUidRef ? (
                    <>
                        <p>All Home Office automations within this Application Folder will be associated with and use data from the {enquiryUidRef.replace("ENQUIRY_", "Enquiry ")}.</p>
                    </>
                ) : (
                    <>
                        <p>You can skip the eligibility evaluation and go straight to using AORA’s automated form-filling of official Home Office forms by creating a Standalone Application.</p>
                        <p>The information used for the forms is taken directly from questionnaires.</p>
                        <p>Please read our <span className="link" onClick={() => AlertModal({width: "700px", body: <StandaloneAutomationDisclaimer />})}>disclaimer</span> before proceeding.</p>
                    </>
                )}

                <Field.Text 
                    formik 
                    name="name" 
                    label="Application name"
                    value={formik.values.name}
                    warning={formik.errors.name}
                    onChange={formik.handleChange} />
            </div>

            <div className="form-buttons">
                <Button
                    className="btn btn-sm" 
                    onClick={() => store.AlertStore.Close()}>
                    Cancel
                </Button>
                
                <Button
                    color="success" 
                    variant="contained" 
                    className="btn btn-sm" 
                    disabled={formik.isSubmitting}
                    type="submit">
                    {enquiryUidRef ? "Create Application" : "Create Standalone Application"}
                </Button>
            </div>
        </form>
    )
}


function StandaloneAutomationDisclaimer () {
    return (
        <div className="form">
            <h2>Standalone Automation Disclaimer</h2>
            
            <div>
                <p>We recommend accessing the automations through completing an assessment using the “Create Enquiry” button on the left-hand side of the screen. AORA will ask questions to assess whether the Skilled Worker is eligible for Entry Clearance, or Further Leave to Remain as a Skilled Worker. If the assessment is successful, you will then have access to automate the CoS and Visa Application forms that are specifically applicable to the applicant.</p>
                <p>By pressing “Yes”, you will have access to automate any of the Sponsor Management System or Visa Application forms using your completed questionnaire(s). <b>As such, it is CRUCIAL that you ensure the questionnaires you select are correct for the form you wish to automate.</b> If these do not match, the automation may fail to complete. <b>You must also ensure all information entered in the questionnaires is correct, as the exact answers will be used to pre-populate the selected form(s).</b></p>
                <h3>NO ASSESSMENT OF ELIGIBILITY WILL BE MADE. </h3>
                <p>Running an automation through these means will skip any assessment conducted by AORA. As such, AORA cannot verify that the information in the questionnaires will lead to a successful CoS or visa application. It cannot be certain that any forms automated here will be granted. </p>
                <p>You must ensure that the information entered in the questionnaires is correct and will be sufficient to meet all eligibility, suitability and validity requirements that are described in Appendix Skilled Worker <a className="link" target="_blank" href="https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-skilled-worker">https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-skilled-worker</a>. The salary must also meet the requirements as outlined in Appendix Skilled Occupations <a className="link" target="_blank" href="https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-skilled-occupations">https://www.gov.uk/guidance/immigration-rules/immigration-rules-appendix-skilled-occupations</a>.</p>
            </div>
            
            <div className="form-buttons">
                <Button 
                    className="btn btn-sm" 
                    color="success" 
                    variant="contained"
                    onClick={() => store.AlertStore.Close()}>
                    Accept and continue
                </Button>
            </div>
        </div>
    )
}